import axios from "axios"

const BASE_URL = "https://abmikgxgxl.execute-api.us-east-1.amazonaws.com/prod"
const HEADERS = {
  'Content-Type': 'application/json'}

const config = axios.create({
	baseURL: BASE_URL,
	headers: HEADERS
})

export default config